export default __webpack_public_path__ + "OfeliaText-Regular.woff";